/* sp-mints-hover.js — "mints drop into the tin" on hover, for any mints product image.
   Markup: an element with data-mints-hover="<Flavor>" that contains the product <img>. Frame URLs come from
   the JSON script tag #sp-mints-hover-sets: {"Strawberry":[...30 urls],"Pineapple":[...],...}.
   Idle = the normal photo, untouched. Hover / keyboard focus (on the closest .pcard, or the element itself):
   a canvas fades in over the photo (150 ms) and plays the set once in 1.6 s (ease-out), then holds; leaving fades back
   and resets. Touch (no hover): plays once per page load when >= 60 % visible. prefers-reduced-motion: nothing.
   Frames load on first hover intent (touch: when the card nears the viewport); the photo stays until all are ready.
   The canvas has pointer-events:none and is absolutely positioned over the photo, so links, taps, swipes and layout
   are unaffected. */
(function () {
  "use strict";
  if (window.__spMintsHover) return; window.__spMintsHover = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  var el = document.getElementById("sp-mints-hover-sets"), SETS = null;
  try { SETS = el ? JSON.parse(el.textContent) : null; } catch (e) {}
  if (!SETS) return;
  var canHover = !!(window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches);
  var DUR = 1600, FADE = 150, cache = {};

  function loadSet(name) {
    if (cache[name]) return cache[name];
    var urls = SETS[name]; if (!urls || !urls.length) return null;
    var st = cache[name] = { imgs: [], ready: false, waiters: [] }, left = urls.length;
    urls.forEach(function (u, i) {
      var im = new Image(); im.decoding = "async";
      im.onload = im.onerror = function () { if (--left === 0) { st.ready = st.imgs.every(function (x) { return x.naturalWidth > 0; }); st.waiters.splice(0).forEach(function (f) { f(); }); } };
      im.src = u; st.imgs[i] = im;
    });
    return st;
  }
  function setName(host) { var n = host.getAttribute("data-mints-hover"); return n && SETS[n] ? n : null; }

  function place(host, canvas) {
    var img = host.querySelector("img"); if (!img) return false;
    /* layout box (ignores hover transforms on the photo); the canvas then mirrors the photo's transform */
    var w = img.offsetWidth, h = img.offsetHeight;
    if (!w || !h) return false;
    var side = Math.min(w, h);                                  /* the photo is object-fit:contain: cover the square it occupies */
    if (getComputedStyle(img).objectFit === "cover") side = Math.max(w, h);
    canvas.style.width = canvas.style.height = side + "px";
    canvas.style.left = (img.offsetLeft + (w - side) / 2) + "px";
    canvas.style.top = (img.offsetTop + (h - side) / 2) + "px";
    host.__mhImg = img;
    return true;
  }
  function ensureCanvas(host) {
    if (host.__mh) return host.__mh;
    if (getComputedStyle(host).position === "static") host.style.position = "relative";
    var c = document.createElement("canvas");
    c.width = c.height = 600; c.setAttribute("aria-hidden", "true"); c.className = "sp-mh-canvas";
    c.style.cssText = "position:absolute;z-index:3;pointer-events:none;opacity:0;transition:opacity " + FADE + "ms linear;display:block;";
    host.appendChild(c);
    return (host.__mh = { c: c, ctx: c.getContext("2d"), raf: 0, token: 0, on: false });
  }
  function stop(host) {
    var m = host.__mh; if (!m) return;
    m.token++; m.on = false;
    if (m.raf) { cancelAnimationFrame(m.raf); m.raf = 0; }
    m.c.style.opacity = "0";
  }
  function play(host, after) {
    var name = setName(host); if (!name) return;
    var st = loadSet(name); if (!st) return;
    var m = ensureCanvas(host), token = ++m.token; m.on = true;
    function go() {
      if (token !== m.token || !st.ready || !place(host, m.c)) return;   /* left before the frames were ready, or a failed frame: keep the photo */
      var n = st.imgs.length, t0 = 0, last = -1;
      m.ctx.drawImage(st.imgs[0], 0, 0, 600, 600);
      m.c.style.opacity = "1";
      (function frame(ts) {
        if (token !== m.token) return;
        if (!t0) t0 = ts || performance.now();
        var t = Math.max(0, Math.min(1, ((ts || performance.now()) - t0) / DUR)), e = 1 - Math.pow(1 - t, 3);
        var i = Math.max(0, Math.min(n - 1, Math.round(e * (n - 1))));
        if (!st.imgs[i] || !st.imgs[i].naturalWidth) { m.raf = requestAnimationFrame(frame); return; }
        if (i !== last) { m.ctx.drawImage(st.imgs[i], 0, 0, 600, 600); last = i; }
        if (host.__mhImg) { var tf = getComputedStyle(host.__mhImg).transform; if (tf !== m.tf) { m.c.style.transform = tf === "none" ? "" : tf; m.tf = tf; } }
        if (t < 1) m.raf = requestAnimationFrame(frame); else { m.raf = 0; if (after) after(); }
      })(0);
    }
    if (st.ready) go(); else st.waiters.push(go);
  }

  function bind(host) {
    if (host.__mhBound) return; host.__mhBound = true;
    var trig = host.closest(".pcard") || host;
    if (canHover) {
      trig.addEventListener("mouseenter", function () { play(host); });
      trig.addEventListener("mouseleave", function () { stop(host); });
      trig.addEventListener("focusin", function () { if (!host.__mh || !host.__mh.on) play(host); });
      trig.addEventListener("focusout", function (e) { if (!trig.contains(e.relatedTarget)) stop(host); });
    } else if ("IntersectionObserver" in window) {
      var played = false;
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) { var n = setName(host); if (n) loadSet(n); } }, { rootMargin: "300px 0px" }).observe(host);
      var io = new IntersectionObserver(function (es) {
        if (played || !es[0].isIntersecting || es[0].intersectionRatio < 0.6) return;
        played = true; io.disconnect();
        play(host, function () { setTimeout(function () { stop(host); }, 1400); });
      }, { threshold: [0.6] });
      io.observe(host);
    }
    /* if the flavor on this element changes (PDP chips / thumbnails), drop back to the photo */
    if ("MutationObserver" in window) new MutationObserver(function () { stop(host); if (canHover && trig.matches(":hover") && setName(host)) play(host); })
      .observe(host, { attributes: true, attributeFilter: ["data-mints-hover"] });
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll("[data-mints-hover]"), bind); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.addEventListener("resize", function () { Array.prototype.forEach.call(document.querySelectorAll("[data-mints-hover]"), function (h) { if (h.__mh && h.__mh.on) place(h, h.__mh.c); }); });
})();
